// telehealthGuards.ts
export const consultEndedKey = (cid: string) => `telehealth_consult_ended_v1:${cid}`;

export function markConsultEnded(cid: string) {
  try {
    sessionStorage.setItem(consultEndedKey(cid), String(Date.now()));
  } catch {}
}

export function clearConsultEnded(cid: string) {
  try {
    sessionStorage.removeItem(consultEndedKey(cid));
  } catch {}
}

export function isConsultEnded(cid: string) {
  try {
    return !!sessionStorage.getItem(consultEndedKey(cid));
  } catch {
    return false;
  }
}